import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';


export default function CheckmarkAnimation() {
    const navigate = useNavigate();


    return (
        <div className="relative w-full h-screen overflow-hidden flex justify-center items-center">
            <img className="absolute inset-0 w-full h-full object-cover" src="/images/end_screen_photo.png" alt="Children Background" />
            <div className="relative z-10 w-full max-w-2xl flex flex-col items-center p-8 pt-40 md:pt-10">
                <p className="text-3xl md:text-5xl font-bold text-footerBlue mb-8">
                    Uspješno ste zakazali rođendan
                </p>
                <div className="bg-noteBgRed w-full rounded-[35px] p-8 shadow-lg space-y-3 flex flex-col justify-center items-center">
                    <p className="text-noteDetailsRed text-center font-semibold text-lg md:text-xl">
                        Potvrda o zakazivanju će vam stići na email adresu.
                    </p>
                    <p className="text-noteDetailsRed text-center font-semibold text-lg md:text-xl">
                        Nakon izvršene uplate avansa, vaš termin će biti rezervisan.
                    </p>
                    <p className="text-noteDetailsRed text-center font-semibold text-lg md:text-xl">
                        Rok za uplatu avansa je 7 dana.
                    </p>
                </div>
            </div>
        </div>
    );
}